module.exports = __webpack_public_path__ + "static/media/image1.02944811.jpg";